import NavigateButton from "../ArrowButton/NavigateButton";
import "./Product.css";

const Product = () => {
  return (
    <div className="product-container">
      <h1 className="product-title">Dòng Sản Phẩm Rumi</h1>
      <p className="product-subtitle">Các sản phẩm nổi bật của chúng tôi</p>

      {/* --- Block: Tã Dán --- */}
      <div className="row product-block bg-soft-pink">
        <div className="col-12 col-sm-6 image-col">
          <img className="product-img" src="./images/dan.png" alt="ta dan" />
        </div>

        <div className="col-12 col-sm-6 text-col">
          <h4 className="product-heading green">TÃ DÁN</h4>
          <p>ÊM MỀM, THOÁNG KHÍ, CHỐNG TRÀN HOÀN HẢO</p>
          <p className="text-description">
            Tã dán Rumi đạt chứng nhận tiêu chuẩn SGS và TCVN 10584:2014, được
            sản xuất theo quy trình hiện đại đạt chuẩn FDA, đảm bảo an toàn
            tuyệt đối cho làn da nhạy cảm của bé. Lấy cảm hứng từ hình tượng Cụ
            Rùa ngàn năm Hồ Gươm – biểu tượng của sự chở che và bền vững, Rumi
            khắc họa hình ảnh thiên thần nhỏ trong bộ mai rùa nằm trên mây, gửi
            gắm thông điệp về tình yêu thương và sự thuần khiết mang đậm tinh
            thần Việt. Với bề mặt vân 3D thoáng khí, lõi thấm 5 lớp SAP siêu
            mỏng chỉ 1,5mm cùng vách chống tràn cao 5cm ôm khít, Rumi giúp bé
            luôn khô ráo và dễ chịu suốt cả ngày. Thiết kế miếng dán linh hoạt
            và vạch báo đầy tiện lợi giúp mẹ chăm bé nhẹ nhàng, an tâm hơn mỗi
            ngày.
          </p>

          <NavigateButton cat="Tã Dán" />
        </div>
      </div>

      <div className="wave-wrapper down">
        <img
          src="/images/wave-animated.svg"
          className="wave"
          style={{ color: "#f0e4d7" }}
          alt="wave"
        />
      </div>

      {/* --- Block: TÃ QUẦN --- */}
      <div className="row product-block bg-soft-beige reverse">
        <div className="col-12 col-sm-6 text-col bg-soft-green">
          <h4 className="product-heading pink">TÃ QUẦN</h4>
          <p>VỪA VẶN ÊM ÁI, THOẢI MÁI CẢ NGÀY</p>
          <p className="text-description">
            Tã quần Rumi đạt chứng nhận tiêu chuẩn SGS và TCVN 10584:2014, được
            sản xuất tại nhà máy đạt chuẩn FDA, đảm bảo an toàn tuyệt đối cho
            làn da nhạy cảm của bé. Lấy cảm hứng từ Cụ Rùa ngàn năm Hồ Gươm –
            biểu tượng của sự chở che và tình yêu thuần khiết, Rumi khắc họa
            hình ảnh thiên thần nhỏ trong bộ mai rùa nằm trên mây, gửi gắm thông
            điệp yêu thương Việt đến từng em bé. Với đai chun không áp lực, co
            giãn linh hoạt ôm sát cơ thể, cùng lõi thấm 5 lớp SAP siêu mỏng chỉ
            1,5mm thấm hút nhanh và chống thấm ngược, Rumi giúp bé luôn thoải
            mái trong từng vận động. Bề mặt vải dệt nhiệt siêu mềm, kết hợp cấu
            trúc 3D thoáng khí và vách chống tràn cao 5cm ôm khít, giữ cho da bé
            khô thoáng, dễ chịu suốt ngày dài. Ngoài ra, vạch báo đầy thông minh
            giúp mẹ chăm con tiện lợi và an tâm hơn mỗi ngày.
          </p>

          <NavigateButton cat="Tã Quần" />
        </div>
        <div className="col-12 col-sm-6 image-col">
          <img className="product-img" src="./images/quan.png" alt="ta quan" />
        </div>
      </div>

      <div className="wave-wrapper up rotate">
        <img src="/images/wave-animated.svg" className="wave" alt="wave" />
      </div>

      {/* --- Block: New Born --- */}
      <div className="row product-block bg-soft-cream">
        <div className="col-12 col-sm-6 image-col">
          <img className="product-img" src="./images/NB.png" alt="new born" />
        </div>
        <div className="col-12 col-sm-6 text-col bg-soft-purple">
          <h4 className="product-heading violet">NEW BORN</h4>
          <p>ÊM ÁI, THOÁNG KHÍ, AN TOÀN CHO BÉ SƠ SINH</p>
          <p className="text-description">
            Tã dán Newborn Rumi đạt chứng nhận tiêu chuẩn SGS và TCVN
            10584:2014, được sản xuất theo quy trình hiện đại đạt chuẩn FDA, đảm
            bảo an toàn tuyệt đối cho làn da nhạy cảm của bé. Lấy cảm hứng từ Cụ
            Rùa ngàn năm Hồ Gươm – biểu tượng của sự chở che và tình yêu thuần
            khiết, Rumi khắc họa hình ảnh thiên thần nhỏ trong bộ mai rùa nằm
            trên mây, gửi gắm thông điệp yêu thương Việt đến từng em bé. Với bề
            mặt vân 3D thoáng khí, chất vải dệt nhiệt siêu mềm và rãnh rốn Oheso
            viền mềm mại, Rumi giúp bảo vệ cuống rốn bé luôn khô ráo, êm ái. Lõi
            thấm 5 lớp SAP siêu mỏng chỉ 1,5mm thấm hút nhanh, chống thấm ngược
            hiệu quả, kết hợp cùng vách chống tràn cao 5cm ôm sát và miếng dán
            linh hoạt, vạch báo ướt tiện lợi, mang đến cho mẹ trải nghiệm chăm
            con gọn gàng, nhẹ nhàng và an tâm hơn mỗi ngày.
          </p>

          <NavigateButton cat="Newborn" />
        </div>
      </div>
    </div>
  );
};

export default Product;
